import type { z } from 'zod';
import { ProdutoPacoteBarraSchema } from '@/features/produto/types/ProdutoPacoteBarra';

export const TabelaPrecoProdutoPacoteBarraPartialSchema = ProdutoPacoteBarraSchema.pick({
    pcb_descricao: true,
    pcb_multiplicador: true,
    pcb_tipo_preco: true,
    pcb_valor: true,
});

export type TabelaPrecoProdutoPacoteBarraPartial = z.infer<
    typeof TabelaPrecoProdutoPacoteBarraPartialSchema
>;
